/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_PlaceholderInputs */

const en_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const fr_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const de_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const it_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const ru_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const es_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const zh_cn2_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const ja_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const hi_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

const pt_pt2_timecode_placeholder = /** @type {(inputs: Timecode_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`00:00:00:00`)
};

/**
* | output |
* | --- |
* | "00:00:00:00" |
*
* @param {Timecode_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_placeholder = /** @type {((inputs?: Timecode_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timecode_placeholder(inputs)
	if (locale === "de") return de_timecode_placeholder(inputs)
	if (locale === "it") return it_timecode_placeholder(inputs)
	if (locale === "ru") return ru_timecode_placeholder(inputs)
	if (locale === "es") return es_timecode_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_timecode_placeholder(inputs)
	if (locale === "ja") return ja_timecode_placeholder(inputs)
	if (locale === "hi") return hi_timecode_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_timecode_placeholder(inputs)
	return en_timecode_placeholder(inputs)
});